import { updateProduct } from "../product/actions";
import {
  UPDATE_PRODUCT_FAIL,
  UPDATE_PRODUCT_REQUEST,
} from "../product/actionType";
import axios from "./utils/axios";

const fetchUpdateProduct = (id, sku, product) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: UPDATE_PRODUCT_REQUEST });
      const {
        login: { userInfo },
      } = getState();
      const config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };
      const { data } = await axios.put(
        `api/product/update/${id}/`,
        { sku: sku, product_name: product },
        config
      );
      dispatch(updateProduct(data));
    } catch (error) {
      dispatch({
        type: UPDATE_PRODUCT_FAIL,
        payload:
          error.response && error.response.data.details
            ? error.response.data.details
            : error.message,
      });
    }
  };
};
export default fetchUpdateProduct;
